import * as React from "react"
const IconAddCircle = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 19}
        height={props.height || 19}
        fill="none"
        viewBox="0 0 19 19"
        {...props}
    >
        <path
            stroke={props.stroke || "#A4A7AE"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.667}
            d="M9.166 5.833V12.5M5.833 9.167H12.5m5 0a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z"
        />
    </svg>
)
export default IconAddCircle
